import { render, staticRenderFns } from "./WalletTransactions.vue?vue&type=template&id=723f81bc&scoped=true"
import script from "./WalletTransactions.vue?vue&type=script&lang=js"
export * from "./WalletTransactions.vue?vue&type=script&lang=js"
import style0 from "./WalletTransactions.vue?vue&type=style&index=0&id=723f81bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f81bc",
  null
  
)

export default component.exports